import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useIsInvalidInternalUser = (): boolean => {
  const user = useAppSelector(userSlice.selectUserInfo);
  if (user) {
    const isALUser = user.emailAddress.endsWith('@americanlogistics.com');
    const hasUserRole = user.access?.userRoles?.some((role: string) =>
      /^tp\..+\.user$/.test(role),
    );
    return isALUser && !hasUserRole;
  }
  return false;
};
